<template>
  <div id="main">
    <div v-show="type" id="chinaEcharts" class="echarts"></div>
    <div v-show="!type" id="globeEcharts" class="echarts"></div>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import 'echarts-gl';
// import china from '@/assets/china.geo.json';
import chinaES from '@/assets/map/china.json';
// import world from '@/assets/allCountriesGeojson.json';
import worldES from '@/assets/map/world.json';
import { statistics } from '@/services/data';
// import { baidugps } from '@/services/data';

require('echarts/extension/bmap/bmap');

export default {
  name: 'globeMap',
  data() {
    return {
      baidu: false, // 使用百度地图
      chinaChart: null, // 中国地图
      chinaChartBmap: null, // 百度中国地图
      globeChart: null, // 全球地图
      globeaChartBmap: null, // 百度全球地图
      chinaStatisticsData: null, // 中国统计数据
      globeStatisticsData: null, // 全球统计数据
      chinaMapZoom: 1, // 全国地图缩放比例
    };
  },
  props: {
    type: {
      type: Number,
      default: 0, // 1 中国 0 全球
    },
  },
  computed: {
    // 全国地图参数
    optionChina() {
      console.log('全国地图 geo 数据', chinaES, this.baidu);
      if (this.baidu) {
        const convertData = () => this.chinaStatisticsData.map((value) => ({
          name: value.name,
          value: [value.lng, value.lat, value.value],
        }));
        return {
          bmap: {
          // 百度地图中心经纬度
            center: [104.114129, 37.550339],
            // 百度地图缩放
            zoom: 1,
            // 是否开启拖拽缩放，可以只设置 'scale' 或者 'move'
            roam: true,
            // 百度地图的自定义样式2.0，见 http://developer.baidu.com/map/jsdevelop-11.htm
            mapStyle: {},
            // 百度地图的自定义样式3.0 http://lbsyun.baidu.com/index.php?title=open/custom
            mapStyleV2: {
              styleId: '602a06804ee9d535cc0315a5479ee341',
            },
            // See https://lbsyun.baidu.com/cms/jsapi/reference/jsapi_reference.html#a0b1
            mapOptions: {
              minZoom: 1, // 地图允许展示的最小级别
              maxZoom: 7, // 地图允许展示的最大级别
              enableMapClick: false,
            },
          },
          tooltip: {
            trigger: 'item',
          },
          visualMap: [
            {
              type: 'continuous', // 连续型
              min: 0, // 最小值
              max: this.chinaStatisticsData[0].value, // 最大值
              itemWidth: 0, // 宽度
              itemHeight: 0, // 高度
              // text: [this.chinaStatisticsData[0].value, 0], // 两端文字
              // dimension: 1, // 选用data的哪列数据
              inRange: {
                color: ['lightskyblue', 'yellow', 'orangered'],
              },
              textStyle: {
                color: '#fff',
              },
            },
          ],

          series: [
            {
              name: '校友总数',
              type: 'effectScatter',
              coordinateSystem: 'bmap',
              data: convertData(),
              symbolSize(val) {
                const scaleSize = Math.ceil(val[2] / 100);
                if (scaleSize > 50) return 50;
                return scaleSize;
              },
              encode: {
                value: 2,
              },
              showEffectOn: 'render',
              rippleEffect: {
                brushType: 'stroke',
              },
              label: {
              // 默认样式（不设置高亮样式时高亮文字消失）
                normal: {
                  formatter: '{b}',
                  position: 'right',
                  show: false,
                },
                // 高亮样式
                emphasis: {
                  formatter: '{b}',
                  position: 'right',
                  show: true,
                },
              },
              itemStyle: {
                shadowBlur: 10,
              },
              emphasis: {
                scale: true,
              },
              zlevel: 1,
            },
          ],
        };
      }
      return {
        // 提示窗
        tooltip: {
          show: true,
          trigger: 'item',
          formatter(value) {
            return `${value.name}: ${value.value ? value.value : 0}位校友`;
          },
        },
        visualMap: [
          {
            type: 'continuous', // 连续型
            min: 0, // 最小值
            max: this.chinaStatisticsData[0].value, // 最大值
            itemWidth: 20, // 宽度
            itemHeight: 140, // 高度
            text: [this.chinaStatisticsData[0].value, 0], // 两端文字
            // dimension: 1, // 选用data的哪列数据
            inRange: {
              color: ['lightskyblue', 'yellow', 'orangered'],
            },
            textStyle: {
              color: '#fff',
            },
          },
        ],
        series: [
          {
            type: 'map',
            name: '全国地图',
            roam: true, // 是否开启平游或缩放
            zoom: this.$store.state.data.type == 8 || this.$store.state.data.type == 30 ? 2 : 1,
            // zoom: this.chinaMapZoom,
            scaleLimit: {
              // 滚轮缩放的极限控制
              min: 1,
              max: 8,
            },
            map: 'china', // 自定义扩展图表类型
            nameMap: {
              // name 映射，用于匹配geoJSON与后端数据
              // tianjin: '天津市',
            },
            nameProperty: 'name',
            selectedMode: true,
            label: {
              // 图形上的文本标签
              show: this.chinaMapZoom > 3,
              position: 'inside',
              color: '#fff',
              fontSize: 12,
            },
            itemStyle: {
              // 图形样式、颜色
            },
            emphasis: {
              // 高亮状态下图形样式、标签样式
              // label: {
              //   color: '#fff',
              // },
            },
            data: this.chinaStatisticsData,
          },
        ],
      };
    },

    // 全球地图参数
    optionGlobe() {
      console.log('全球地图 geo 数据', worldES, this.baidu);
      if (this.baidu) {
        const convertData = () => this.globeStatisticsData.map((value) => ({
          name: value.name,
          value: [value.lng, value.lat, value.value],
        }));
        return {
          bmap: {
            id: 'world',
            // 百度地图中心经纬度
            center: [104.114129, 37.550339],
            // 百度地图缩放
            zoom: 1,
            // 是否开启拖拽缩放，可以只设置 'scale' 或者 'move'
            roam: true,
            // 百度地图的自定义样式2.0，见 http://developer.baidu.com/map/jsdevelop-11.htm
            mapStyle: {},
            // 百度地图的自定义样式3.0 http://lbsyun.baidu.com/index.php?title=open/custom
            mapStyleV2: {
              styleId: '602a06804ee9d535cc0315a5479ee341',
            },
            // See https://lbsyun.baidu.com/cms/jsapi/reference/jsapi_reference.html#a0b1
            mapOptions: {
              minZoom: 1, // 地图允许展示的最小级别
              maxZoom: 4, // 地图允许展示的最大级别
              enableMapClick: false,
            },
          },
          tooltip: {
            trigger: 'item',
          },
          visualMap: [
            {
              type: 'continuous', // 连续型
              min: 0, // 最小值
              max: this.globeStatisticsData[0].value, // 最大值
              itemWidth: 0, // 宽度
              itemHeight: 0, // 高度
              // text: [this.globeStatisticsData[0].value, 0], // 两端文字
              // dimension: 1, // 选用data的哪列数据
              inRange: {
                color: ['lightskyblue', 'yellow', 'orangered'],
              },
              textStyle: {
                color: '#fff',
              },
            },
          ],

          series: [
            {
              id: 'world',
              name: '校友总数',
              type: 'effectScatter',
              coordinateSystem: 'bmap',
              data: convertData(),
              symbolSize(val) {
                const scaleSize = Math.ceil(val[2] / 100);
                if (scaleSize > 50) return 50;
                return scaleSize;
              },
              encode: {
                value: 2,
              },
              showEffectOn: 'render',
              rippleEffect: {
                brushType: 'stroke',
              },
              label: {
                formatter: '{b}',
                position: 'right',
                show: true,
              },
              itemStyle: {
                shadowBlur: 10,
              },
              emphasis: {
                scale: true,
              },
              zlevel: 1,
            },
          ],
        };
      }
      return {
        // 提示窗
        tooltip: {
          show: true,
          trigger: 'item',
          formatter(value) {
            return `${value.name}${value.name ? ': ' : ''}${value.value ? value.value : 0}位校友`;
          },
        },
        visualMap: [
          {
            type: 'continuous', // 连续型
            min: 0, // 最小值
            max: this.globeStatisticsData[0].value, // 最大值
            itemWidth: 20, // 宽度
            itemHeight: 140, // 高度
            text: [this.globeStatisticsData[0].value, 0], // 两端文字
            // dimension: 1, // 选用data的哪列数据
            inRange: {
              color: ['lightskyblue', 'yellow', 'orangered'],
            },
            textStyle: {
              color: '#fff',
            },
          },
        ],
        series: [
          {
            type: 'map',
            name: '全球地图',
            roam: true, // 是否开启平游或缩放
            zoom: this.$store.state.data.type == 8 || this.$store.state.data.type == 30 ? 2 : 1,
            center: this.$store.state.data.type == 8 || this.$store.state.data.type == 30 ? [22, 20] : undefined,
            scaleLimit: {
              // 滚轮缩放的极限控制
              min: 1,
              max: 16,
            },
            map: 'world', // 自定义扩展图表类型
            nameMap: {
              // name 映射，用于匹配geoJSON与后端数据
              // tianjin: '天津市',
            },
            // nameProperty: 'name', // 英文
            nameProperty: 'cname', // 中文
            label: {
              // 图形上的文本标签
              show: false,
            },
            itemStyle: {
              // 图形样式、颜色
              color: '#eee',
            },
            emphasis: {
              // 高亮状态下图形样式、标签样式
            },
            data: this.globeStatisticsData,
          },
        ],
      };
    },
  },
  watch: {
    type: {
      handler(newName, oldName) {
        console.log(newName, oldName);
        if (oldName !== undefined) {
          this.getStatistics();
        }
      },
      immediate: true,
      deep: true,
    },
  },
  created() {
    // window.addEventListener('resize', (e) => {
    //   console.log('resize', e);
    //   this.myChart.resize();
    // });
  },
  mounted() {
    // 获取echarts挂载dom实例
    const chinaChartDom = document.getElementById('chinaEcharts');
    // 创建echarts实例
    this.chinaChart = echarts.init(chinaChartDom);
    echarts.registerMap('china', chinaES);

    // 获取echarts挂载dom实例
    const globeChartDom = document.getElementById('globeEcharts');
    // 创建echarts实例
    this.globeChart = echarts.init(globeChartDom);
    echarts.registerMap('world', worldES);

    // 获取数据
    this.getStatistics();
  },
  methods: {
    // 获取统计数据
    async getStatistics() {
      if ((this.type === 0 && this.globeStatisticsData) || (this.type === 1 && this.chinaStatisticsData)) {
        return;
      }
      this.loading = true;
      // eslint-disable-next-line max-len
      const {
        data: {
          data: { data = {} },
        },
      } = await statistics(this.type === 1 ? 3 : 2, 1, 100000);
      // 坐标转换(应由后端处理)
      // eslint-disable-next-line max-len
      // const gps = { status: 0, result: [{ x: 108.94665513973389, y: 34.26062511138288 }, { x: 116.3873408932196, y: 39.98911749342502 }, { x: 113.99434196921273, y: 22.597954227401464 }, { x: 104.06752542490939, y: 30.60394807625148 }, { x: 111.79948653609637, y: 16.210285420343007 }, { x: 113.81315441846913, y: 34.78968699774731 }, { x: 114.33316884312701, y: 30.587164182931358 }, { x: 121.53039199565287, y: 31.24846650546195 }, { x: 120.43326461925938, y: 36.320937425463657 }, { x: 118.91546449506487, y: 32.110884444220349 }, { x: 117.12663338207462, y: 31.82472663975926 }, { x: 112.99258895155289, y: 28.133328526614564 }, { x: 102.72431142521775, y: 24.988688590561048 }, { x: 108.63312426932933, y: 21.972866604709915 }, { x: 121.55546248751615, y: 38.88481298597392 }, { x: 102.91807070339635, y: 34.991716491579428 }, { x: 116.20654294349461, y: 39.56582011794191 }, { x: 126.99715665639, y: 46.640893884990358 }, { x: 122.65748096626109, y: 45.73791068396779 }, { x: 121.58340162613182, y: 29.86953527448585 }, { x: 112.72021554551749, y: 37.751289160048887 }, { x: 114.93043186933957, y: 27.82505896522093 }, { x: 119.57165783433807, y: 26.739023475798427 }, { x: 106.66961565331825, y: 26.632836578043724 }, { x: 125.94332229743573, y: 41.72685512281561 }, { x: 101.8113598927194, y: 36.61434853095691 }, { x: 94.36754796762054, y: 29.65958193280833 }, { x: 106.38327892643784, y: 39.01984841389728 }, { x: 117.20248428962097, y: 39.124089918278809 }, { x: 106.40080985853844, y: 29.818512470372967 }, { x: 82.99061956422425, y: 46.75203428522433 }, { x: 114.16693735484378, y: 22.328423106395677 }] };
      // gps.result.forEach((value, index) => {
      //   data[index].lat = value.y;
      //   data[index].lng = value.x;
      // });
      // try {
      //   console.log(data.map((value) => `${value.lng},${value.lat}`).join(';'), 2234);
      //   const baidu = await baidugps(data.map((value) => `${value.lng},${value.lat}`).join(';'));
      //   console.log(baidu, 1123);
      // } catch (err) {
      //   console.log(err);
      // }
      if (this.type === 1) {
        this.chinaStatisticsData = data;
      } else {
        this.globeStatisticsData = data;
      }
      console.log('统计数据： ', data);
      if (this.type === 0) {
        this.setGlobeOptions();
      } else {
        this.setChinaOptions();
      }
    },

    // 设置全国 echarts 图表
    setChinaOptions() {
      this.chinaChart.showLoading();
      this.chinaChart.setOption(this.optionChina);
      this.chinaChart.hideLoading();
      // 设置百度地图
      if (this.baidu) {
        // 获取 bmap 实例
        this.chinaChartBmap = this.chinaChart.getModel().getComponent('bmap').getBMap();
        // 禁用双击放大
        this.chinaChartBmap.disableDoubleClickZoom();
        // 监听 bmap 缩放结束事件
        this.chinaChartBmap.addEventListener('zoomend', () => {
          const level = this.chinaChartBmap.getZoom();
          const data = this.chinaChart.getOption();
          console.log('缩放结束', level, data);
          if (data.series[0].label.show && level <= 4) {
            this.chinaChart.showLoading();
            data.series[0].label.show = false;
            this.chinaChart.setOption(data, { replaceMerge: ['series'] });
          }
          if (!data.series[0].label.show && level > 4) {
            this.chinaChart.showLoading();
            data.series[0].label.show = true;
            this.chinaChart.setOption(data, { replaceMerge: ['series'] });
          }
          this.chinaChart.hideLoading();
        });
        console.log('全国百度地图实例', this.chinaChartBmap, this.chinaChartBmap.getZoom());
      } else {
        // 监听平移缩放，判断是否显示地图上的文字
        this.chinaChart.on('geoRoam', () => {
          const data = this.chinaChart.getOption();
          if (data.series[0].label.show && data.series[0].zoom <= 2) {
            data.series[0].label.show = false;
            this.chinaChart.clear();
            this.chinaChart.setOption(data);
          }
          if (!data.series[0].label.show && data.series[0].zoom > 2) {
            data.series[0].label.show = true;
            this.chinaChart.clear();
            this.chinaChart.setOption(data);
          }
        });
      }
    },

    // 设置全球 echarts 图表
    setGlobeOptions() {
      this.globeChart.setOption(this.optionGlobe);
      // 监听平移缩放，判断是否显示地图上的文字
      this.globeChart.on('geoRoam', () => {
        const data = this.globeChart.getOption();
        if (data.series[0].label.show && data.series[0].zoom <= 4) {
          data.series[0].label.show = false;
          this.globeChart.clear();
          this.globeChart.setOption(data);
        }
        if (!data.series[0].label.show && data.series[0].zoom > 4) {
          data.series[0].label.show = true;
          this.globeChart.clear();
          this.globeChart.setOption(data);
        }
      });
    },

    // 转换百度坐标
    // baidugps() {
    //   // eslint-disable-next-line no-undef
    //   const convertor = new BMap.Convertor();
    //   this.chinaStatisticsData = this.chinaStatisticsData.slice(0, 10);
    //   convertor.translate(this.chinaStatisticsData.slice(0, 10), 3, 5, (res) => {
    //     console.log('转换完成', res);
    //   });
    // },
  },
};
</script>

<style lang="less" scoped>
// @scale: (100vw / 750px);
#main {
  position: absolute;
  z-index: 1;
  top: calc(50vh - 50vw);
  width: 100vw;
  height: 100vw;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
  .echarts {
    width: 100vw;
    height: 100vw;
  }
}

// 去掉文字那行，添加CSS即可
/deep/ .BMap_cpyCtrl {
    display: none !important;
}
// 去掉地图那行，添加CSS即可
/deep/ .anchorBL{
    display: none !important;
}

</style>
